module.exports = __webpack_public_path__ + "static/media/house_15.39715dda.jpg";